import React from "react";
import { Box } from "@mui/material";
import { OptionsSection } from "../styles/styled.components";
import CheckboxCard from "../CheckboxCard";
import { CHECKBOX_OPTIONS } from "../constants/config";

const OptionsArea = ({
  checkboxes = {},
  onCheckboxChange,
  selection,
  sliderValues,
  setSliderValues,
}) => {
  const handleSliderChange = (optionName, newValue) => {
    setSliderValues((prev) => ({
      ...prev,
      [optionName]: newValue,
    }));
  };
  return (
    <OptionsSection>
      <div className="num_title">중요도 설정</div>
      <Box
        sx={{
          display: "grid",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "20px 0",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "1.2rem",
          margin: "0 auto",
        }}
      >
        {CHECKBOX_OPTIONS.map((option) => {
          return (
            <CheckboxCard
              key={option.name}
              checked={checkboxes[option?.name]}
              label={option.label}
              disabled={option.forwardOnly && selection === "Backward"}
              selection={selection}
              sliderValue={sliderValues[option.name]}
              onSliderChange={(newValue) =>
                handleSliderChange(option.name, newValue)
              }
            />
          );
        })}
      </Box>
    </OptionsSection>
  );
};

export default React.memo(OptionsArea);
